module.exports = __webpack_public_path__ + "img/analitycs-card.c829d57b.svg";